import { Link } from "react-router-dom";
import { Calculator, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";

export function CTASection() {
  const { t } = useLanguage();

  return (
    <section className="py-24 bg-gradient-to-br from-primary to-[hsl(210,60%,35%)] relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-secondary rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-72 h-72 bg-primary-foreground rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-display font-bold text-3xl md:text-4xl lg:text-5xl text-primary-foreground mb-6">
            {t("cta.title")}
          </h2>
          <p className="text-xl text-primary-foreground/80 mb-10 max-w-2xl mx-auto">
            {t("cta.subtitle")}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild size="lg" className="bg-secondary hover:bg-secondary/90 text-secondary-foreground font-bold px-8 py-6 text-lg rounded-xl shadow-2xl hover:shadow-secondary/25 transition-all hover:scale-105">
              <Link to="/kalkulator">
                <Calculator className="w-5 h-5 mr-2" />
                {t("cta.button_calculator")}
              </Link>
            </Button>
            <Button asChild size="lg" className="bg-transparent border-2 border-white/40 text-white hover:bg-white/10 font-bold px-8 py-6 text-lg rounded-xl">
              <a href="tel:+421907999909">
                <Phone className="w-5 h-5 mr-2" />
                {t("cta.button_phone")}
              </a>
            </Button>
          </div>

          <p className="mt-8 text-primary-foreground/60 text-sm">
            {t("cta.footer_text")}
          </p>
        </div>
      </div>
    </section>
  );
}
